import * as React from 'react';
import styled from 'styled-components';
import TextHelper from '../../../../../../../../core/helpers/TextHelper';
import { Icon, Text } from '../../../../../../../components';
import useProfile from '../../../../../../../hooks/useProfile';
import Select from '../../../../../components/Select';
import { SaveButton } from '../../../../scholarships/bse/components/styled';

const Container = styled.div`
  padding: 24px;
  background-color: #fff;
  border-radius: 4px;
  margin: 16px 0px 32px 0px;
  width: 100%;
  .textDiv {
    margin-bottom: 4px;
  }
  .textDiv2 {
    margin-top: 12px;
    margin-bottom: 4px;
  }
  .textDiv3 {
    margin-top: 8px;
    display: flex;
    gap: 5px;
  }
`;
interface RegisterFormProps {
  options: any[];
  optionsPeriod: any[];
  changeOption: (option: any) => void;
  changePeriod: (period: any) => void;
  onSubmit: () => void;
  currentModality: string;
  currentCareer: string;
  selectedOption: any;
  selectedPeriod: any;
  optionsCampus: any[];
  selectedCampusData: any;
  changeCampus: (campus: any) => void;
  isLoadingModalityOptionList: boolean;
  handlerChangeCycle: (option: any) => void;
  optionsTurns: any;
  selectedTurn: any;
  isEntering: boolean;
}

const RegisterForm: React.FC<RegisterFormProps> = (props) => {
  const {
    options,
    optionsPeriod,
    changeOption,
    changePeriod,
    onSubmit,
    currentModality,
    currentCareer,
    selectedOption,
    selectedPeriod,
    optionsCampus,
    selectedCampusData,
    changeCampus,
    isLoadingModalityOptionList,
    handlerChangeCycle,
    optionsTurns,
    selectedTurn,
    isEntering
  } = props;
  const { academic } = useProfile();
  const { isCGT = false } = academic;

  const validCampusList = optionsCampus?.length > 1;

  const validateDisabled = () => {
    // el alumno no es ingresante y es 100% virtual
    if (validCampusList && !isEntering) {
      return !!(selectedPeriod && selectedOption && selectedCampusData);
    }

    // el alumnno no es ingresante y no es 100% virtual
    if (!validCampusList && !isEntering) {
      return !!(selectedPeriod && selectedOption);
    }

    // el alumno es ingresante y es 100% virtual
    if (validCampusList && isEntering) {
      return !!(
        selectedPeriod &&
        selectedOption &&
        selectedCampusData &&
        selectedTurn
      );
    }

    // el alumno es ingresante y no es 100% virtual
    if (!validCampusList && isEntering) {
      return !!(selectedPeriod && selectedOption && selectedTurn);
    }

    return false;
  };

  return (
    <Container>
      <div className="textDiv">
        <Text color="#1A055D">
          Actualmente estás en la{' '}
          <b>{TextHelper.capitalize(currentModality)}</b> en la carrera de{' '}
          <b>{TextHelper.capitalize(currentCareer)}</b>.
          {isCGT && (
            <>
              <br />
              Los cursos son modulares y tienen una duración de 9 semanas.
            </>
          )}
        </Text>
      </div>
      {validCampusList && (
        <div style={{ marginTop: '16px', color: '#161D1F' }}>
          Para realizar un cambio a una opción con presencialidad, debes elegir
          un campus desde el cual llevarás tus clases presenciales.
        </div>
      )}

      {validCampusList && (
        <>
          <div className="textDiv2">
            <Text>
              Selecciona <strong>campus</strong>:{' '}
            </Text>
          </div>
          <Select
            options={optionsCampus.map((e: any) => ({
              value: e.id,
              label: e.name
            }))}
            placeholder="Elige el campus"
            handleChangeSelect={changeCampus}
            data-testid="cmp-select-1"
          />
        </>
      )}

      <div className="textDiv2">
        <Text
          color={validCampusList && !selectedCampusData ? '#8090BB' : '#161D1F'}
        >
          Selecciona desde que ciclo te matricularás:
        </Text>
      </div>
      <Select
        options={optionsPeriod}
        placeholder="Elige el ciclo"
        handleChangeSelect={changePeriod}
        disabled={validCampusList && !selectedCampusData}
        data-testid="cmp-select-1"
        value={selectedPeriod}
      />
      <div className="textDiv2">
        <Text color={!selectedPeriod ? '#8090BB' : '#161D1F'}>
          Selecciona la opción que deseas:
        </Text>
      </div>
      <Select
        options={options}
        placeholder="-Opciones de estudio-"
        handleChangeSelect={changeOption}
        disabled={!selectedPeriod}
        value={selectedOption}
        isLoading={isLoadingModalityOptionList}
      />
      {isEntering && (
        <>
          <div className="textDiv2">
            <Text color={!selectedOption ? '#8090BB' : '#161D1F'}>
              Selecciona tu turno:
            </Text>
          </div>
          <Select
            options={optionsTurns}
            placeholder="Elige tu turno"
            handleChangeSelect={handlerChangeCycle}
            disabled={!selectedOption}
            value={selectedTurn}
            isLoading={isLoadingModalityOptionList}
          />
        </>
      )}

      <div className="textDiv3" style={{ marginBottom: '24px' }}>
        <Icon name="alert-circle" size={18} color="#977100" />
        <Text color="#4F6168" fontSize="12px">
          Podrías tener un cambio de nombre en la carrera pero no implica un
          cambio de malla curricular.
        </Text>
      </div>
      <SaveButton
        type="button"
        onClick={onSubmit}
        data-testid="btn-register-change-studies-option"
        // disabled={!(isValid || selectedOption)}
        disabled={!validateDisabled()}
      >
        Solicitar
      </SaveButton>
    </Container>
  );
};

export default RegisterForm;
